import type { MailSummary } from "../net/api";
import { $mailFailed, $mailSummary } from "../state/mail";
import { $panel } from "../state/stores";

/** What the envelope shows: null hides it (no agents), "" means nothing unread or unknown, else the count (spec 2j §2.4). */
export function badgeText(summary: MailSummary | null, failed: boolean): string | null {
  if (!summary || summary.threads.length === 0) return null;
  if (failed || summary.unread_total <= 0) return "";
  return summary.unread_total > 99 ? "99+" : String(summary.unread_total);
}

export function mountMailBadge(el: HTMLElement): void {
  el.innerHTML = `<span class="mail-icon">✉</span><span class="mail-badge-count"></span>`;
  el.title = "信箱（M）";
  const count = el.querySelector<HTMLElement>(".mail-badge-count")!;
  const render = () => {
    const text = badgeText($mailSummary.get(), $mailFailed.get());
    el.classList.toggle("show", text !== null);
    count.textContent = text ?? "";
    count.classList.toggle("has", !!text);
  };
  $mailSummary.subscribe(render);
  $mailFailed.subscribe(render);
  el.addEventListener("click", () => $panel.set("mail"));
}
